export default "__VITE_ASSET__DTYzOkMy__"